<template>
  <div class="main">
    <van-tabs v-model="active" color="#3B87F5" background="#fff" animated title-active-color="#3B87F5" @change="getBomList">
      <van-tab  v-for="(item,index) in typeList" :key="index" :title="item.name" :name="item.value" >
        <div class="bomCont">
          <ul v-if="bomList.length>0">
            <li v-for="(itemss,indexs) in bomList" :key="indexs" @click="changeToPath(itemss.id)">
              <div>{{itemss.fTitle}}</div>
            </li>
          </ul>
          <div v-else style="margin:60px auto 0;text-align:center;">暂无数据</div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import qs from 'qs'
import Vue from 'vue';
import { Tab, Tabs } from 'vant';
import { addBaseAplus } from '../utils/zzdmd.js'
Vue.use(Tab);
Vue.use(Tabs);
export default {
  name: 'problem',
  data () {
    return {
      active:0,
      typeList:[],
      bomList:[]
    }
  },
  created(){
    this.getTypeList()
    this.getBomList()
  },
  mounted(){
    addBaseAplus(this.$route)
  },
  activated(){
    this.getTypeList()
    this.getBomList()
  },
  methods:{
    getTypeList(){
      let param = {
        TypeName:'B10-问题类别'
      }
      this.$post('api/Tools/GetTypeList', qs.stringify(param),{
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then((res)=>{
        if(res.code==1000){
          this.typeList = res.data
        }
      })
    },
    getBomList(){
      let param = {
        ProblemType:this.active
      }
      this.$post('api/ProblemBase/GetProblemBaseList', qs.stringify(param),{
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then((res)=>{
        if(res.code==1000){
          this.bomList = res.data
        }
      })
    },
    changeToPath(id){
      this.$router.push({path:'/problemDetail',query:{id:id}})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main{
  background: #f2f2f2;
  min-height: 100vh;
  position: relative;
}
.bomCont{
  width: 100%;
  box-sizing: border-box;
  padding: 10px 0;
}
.bomCont>ul{
  background: #fff;
  box-sizing: border-box;
  padding: 0 12px;
}
.bomCont>ul>li{
  box-sizing: border-box;
  padding: 18px 0;
  border-bottom: 1px solid #E6E6E6;
  font-size: 16px;
  font-weight: 500;
  color: #333333;
}
.bomCont>ul>li:last-child{
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/page/problem.vue